/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import { useIsMobile, useIsPc } from 'core/hooks/useResponsive';

import titleImg from 'static/class/title.png';
import titleSubImg from 'static/class/title-sub.png';
import { ReactComponent as ArrowRight } from 'static/home/arrow_right.svg';

const Title = () => {
  const { mq } = useTheme();
  const isMobile = useIsMobile();
  const isPc = useIsPc();

  const TitleStyle = css`
    background: linear-gradient(180deg, #d8c9f7 0%, #fff 100%);
    .container {
      max-width: 1200px;
      padding-top: 200px;
      padding-bottom: 180px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .title {
        color: #000;
        font-size: 80px;
        font-weight: 800;
        line-height: 100%;
      }
      .sub {
        margin-top: 20px;
        color: #191919;
        /* color: #000; */
        font-size: 40px;
        font-weight: 800;
        line-height: 56px; /* 140% */
      }
      > .desc {
        margin-top: 10px;
        color: #444;
        /* color: #000; */
        font-size: 20px;
        font-weight: 400;
        line-height: 30px; /* 150% */
        letter-spacing: -0.2px;
      }
      button {
        margin-top: 32px;
        width: 333px;
        padding: 8px 8px 8px 45px;
        display: flex;
        /* margin: 51px auto 0px auto; */
        font-size: 25px;
        border-radius: 999px;
        border: 0;
        background: #000;
        color: #fff;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .arrow {
          width: 57px;
          height: 57px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #6079ff;
          border-radius: 50%;
          .arrow-img {
            position: relative;
            animation: moveArrow 0.6s ease-in-out infinite alternate;
          }
        }
        @keyframes moveArrow {
          0% {
            transform: translateX(-3px);
          }
          100% {
            transform: translateX(3px);
          }
        }
      }
      .img {
        position: relative;
        margin-top: 64px;
        img {
          width: 100%;
        }
      }
      .descWrap {
        margin-top: 42px;
        display: flex;
        align-items: flex-start;
        .imgDescWrap {
          width: 169px;
          img {
            width: 100%;
          }
        }
        > .desc {
          margin-left: 36px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .imgDesc {
            color: #444;
            font-size: 25px;
            font-weight: 600;
            line-height: 150%; /* 37.5px */
            letter-spacing: -0.25px;
            text-align: left;
          }
          .imgSubDesc {
            margin-top: 20px;
            color: #444;
            font-size: 18px;
            font-weight: 400;
            line-height: 27px; /* 150% */
            span {
              margin-left: 4px;
              color: #444;
              font-size: 18px;
              font-weight: 700;
              line-height: 27px; /* 150% */
            }
          }
          .mall {
            color: #999;
            font-size: 18px;
            font-weight: 400;
            line-height: 27px; /* 150% */
          }
        }
      }
    }
    ${mq.mobile} {
      .container {
        padding: 96px 20px 100px;
        .title {
          font-size: 48px;
          font-weight: 800;
          line-height: 56px; /* 116.667% */
        }
        .sub {
          font-size: 20px;
          line-height: 30px; /* 150% */
        }
        > .desc {
          font-size: 16px;
          line-height: 24px; /* 150% */
          letter-spacing: -0.16px;
        }
        button {
          margin-top: 20px;
          width: 195px;
          padding: 8px 10px 8px 20px;
          font-size: 16px;
          .arrow {
            width: 30px;
            height: 30px;
            .arrow-img {
              width: 20px;
              height: 20px;
            }
          }
        }
        .img {
          margin-top: 48px;
        }
        .descWrap {
          margin-top: 0px;
          display: flex;
          flex-direction: column;
          .imgDescWrap {
            width: 39.313px;
            height: 29px;
            img {
              width: 100%;
            }
          }
          > .desc {
            margin-left: 0px;
            .imgDesc {
              margin-top: 12px;
              font-size: 14px;
              line-height: 22px; /* 157.143% */
              letter-spacing: -0.14px;
            }
            .imgSubDesc {
              margin-top: 12px;
              font-size: 14px;
              line-height: 20px; /* 142.857% */
              span {
                font-size: 14px;
                line-height: 20px; /* 142.857% */
              }
            }
            .mall {
              font-size: 14px;
              line-height: 20px; /* 142.857% */
            }
          }
        }
      }
    }
  `;
  return (
    <div css={TitleStyle}>
      <div className="container">
        <h2 className="title">모임·단체</h2>
        <h3 className="sub">
          모임비 버는 가장 알뜰하고 쉬운,
          <br />
          몰파이 모임 쇼핑몰
        </h3>
        <p className="desc">
          동아리, 단체, 친목 등 각종 모임에 필요한 {isMobile && <br />} 물품을
          몰파이에 담아 {isPc && <br />}
          가장 저렴하고 효율적인 구매로{isMobile && <br />} 모임을 더욱 즐겁게
          만들어요.
        </p>
        <a
          href="https://my.mallpie.kr"
          target="_blank"
          rel="noopener noreferrer"
          id="cla_title_bu_mymall"
        >
          <button>
            5분만에 몰 만들기
            <div className="arrow">
              <ArrowRight className="arrow-img" />
            </div>
          </button>
        </a>
        <div className="img">
          <img src={titleImg} alt="모임 단체 | 이미지" title="모임 단체" />
        </div>
        <div className="descWrap">
          <div className="imgDescWrap">
            <img src={titleSubImg} alt="subimage" />
          </div>
          <div className="desc">
            <h3 className="imgDesc">
              매주 일요일 축구 모임에 필요한 생수, 간식, 잡화 등 <br />
              최저가로 구매하고 구매 내역은
              <br />
              모두가 볼 수 있도록 투명하게 관리해요
            </h3>
            <p className="imgSubDesc">
              풋볼 커뮤니티 <span>FC아자자</span>
            </p>
            <p className="mall">azaza.mallpie.kr</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Title;
